<template>
  <div>
      <!-- 数值类型 -->
      <template v-if="['int','double','float'].indexOf(item.dataType.type) >= 0">
        {{!isNaN(value) || value?value:''}}{{item.dataType.specs&&item.dataType.specs.unit?item.dataType.specs.unit:''}}
      </template>

      <!-- bool\enum类型 -->
      <template v-if="['bool','enum'].indexOf(item.dataType.type) >= 0">
        {{!isNaN(value) || value?value:''}}{{item.dataType&&item.dataType.specs[item.value]?'('+item.dataType.specs[item.value]+')':''}}
      </template>
        <!-- text类型 -->
       <template v-if="['text'].indexOf(item.dataType.type) >= 0">
         <el-tooltip v-if="value" :content="value" placement="top" effect="light">
           <div class="ellipsis">{{value?value:''}}</div>
         </el-tooltip>
      </template>
       <!-- date类型 -->
       <template v-if="['date'].indexOf(item.dataType.type) >= 0">
        {{!isNaN(value) || value?value:''}}({{item.dataType.specs.datemsg}})
      </template>
       <!-- Array类型 -->
       <template v-if="['array'].indexOf(item.dataType.type) >= 0">
         <template v-if="['struct'].indexOf( item.dataType.specs.item.type) >= 0">
            <el-select size="mini" @change="arrySelChange" v-model="itemValue" placeholder="请查看">
              <el-option
                v-for="subItem in item.dataType.specs.item.specs"
                :key="subItem.identifier"
                :label="subItem.name"
                :value="subItem.identifier">
              </el-option>
            </el-select>
            <runStateDetailView
                    v-if="arrayChildrenItem"
                    :value="arrayChildrenItem.value"
                    :item="arrayChildrenItem"/>
            <!-- <template  v-for="subItem in item.dataType.specs.item.specs">
                <template v-if="itemValue === subItem.identifier">
                   <runStateDetailView
                     :value="!isNaN(subItem.value) || subItem.value?subItem.value:''"
                    :key="subItem.identifier"
                    :item="subItem"/>
                </template>
            </template> -->
         </template>
         <template v-else>
           ({{`size:`+item.dataType.specs.size}})
         </template>
      </template>
         <!-- struct类型 -->
       <template v-if="['struct'].indexOf(item.dataType.type) >= 0">
          <el-select size="mini" @change="selChange" v-model="structValue" placeholder="请查看">
              <el-option
                v-for="subItem in item.dataType.specs"
                :key="subItem.identifier"
                :label="subItem.name"
                :value="subItem.identifier">
              </el-option>
            </el-select>
             <runStateDetailView
                    v-if="childrenItem"
                    :value="childrenItem.value"
                    :item="childrenItem"/>
      </template>
  </div>
</template>
<script>
export default {
  name: 'runStateDetailView', // 组件递归调用
  props: {
    item: {
      type: Object
    },
    value: {
    }
  },
  data () {
    return {
      itemValue: '',
      structValue: '',
      childrenItem: '',
      arrayChildrenItem: ''
    }
  },
  methods: {
    selChange (selValue) {
      console.log('value:', selValue)
      console.log('this.value:', this.value)
      this.childrenItem = ''
      const specs = this.item.dataType.specs
      specs.forEach(item => {
        if (item.identifier === selValue && this.value) {
          if (this.value.length) {
            for (let j = 0; j < this.value.length; j++) {
              if (!isNaN(this.value[j][selValue] || this.value[j][selValue])) {
                console.log('====================================')
                console.log('找到了')
                console.log('====================================')
                this.childrenItem = Object.assign({}, { value: this.value[j][selValue] }, item)
              }
            }
          } else if (this.value[selValue] || !isNaN(this.value[selValue])) {
            this.childrenItem = Object.assign({}, { value: this.value[selValue] }, item)
          }
        }
      })
    },
    arrySelChange (selValue) {
      console.log('value:', selValue)
      this.arrayChildrenItem = ''
      const specs = this.item.dataType.specs.item.specs
      specs.forEach(item => {
        if (item.identifier === selValue && this.value && this.value.length) {
          for (let j = 0; j < this.value.length; j++) {
            if (!isNaN(this.value[j][selValue] || this.value[j][selValue])) {
              console.log('====================================')
              console.log('找到了')
              console.log('====================================')
              this.arrayChildrenItem = Object.assign({}, { value: this.value[j][selValue] }, item)
              console.log('this.arrayChildrenItem:', this.arrayChildrenItem)
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="less">

</style>
